import axios, { type AxiosInstance } from "axios"
import config from "config"
import type {
  ICreateSimulatorApplication,
  ISimulatorApplication,
  IUpdateSimulatorApplication,
} from "types/simulatorApplicationTypes"

import authService from "./authService"

class SimulatorApplicationService {
  private http: AxiosInstance

  public constructor() {
    this.http = axios.create({
      baseURL: config.apiUrl,
      headers: {
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    })
  }

  public createSimulatorApplication = async (
    createSimulatorApplication: ICreateSimulatorApplication,
  ): Promise<ISimulatorApplication> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.post<ISimulatorApplication>(
      "/simulatorapplication",
      createSimulatorApplication,
      config,
    )

    return data
  }

  public getSimulatorApplications = async (): Promise<Array<ISimulatorApplication>> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.get<Array<ISimulatorApplication>>(
      "/simulatorapplication",
      config,
    )

    return data
  }

  public getSimulatorApplication = async (id: string): Promise<ISimulatorApplication> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.get<ISimulatorApplication>(
      `/simulatorapplication/${id}`,
      config,
    )

    return data
  }

  public updateSimulatorApplication = async (
    simulatorApplicationId: string,
    updateSimulatorApplication: IUpdateSimulatorApplication,
  ): Promise<ISimulatorApplication> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.put<ISimulatorApplication>(
      `/simulatorapplication/${simulatorApplicationId}`,
      updateSimulatorApplication,
      config,
    )

    return data
  }

  public deleteSimulatorApplication = async (simulatorApplicationId: string) => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const resp = await this.http.delete(`/simulatorapplication/${simulatorApplicationId}`, config)

    return resp
  }
}

const simulatorApplicationService = new SimulatorApplicationService()

export default simulatorApplicationService
